// @ts-check
import { debounce } from "../utilities/limiters";

// @ts-ignore
jQuery( function( $ ) {
    /** @type {NodeListOf<HTMLVideoElement>} */
    const videos = document.querySelectorAll( 'video[data-media]' );

    // List of media queries in reverse order
    const mediaQueries = [
        ['large', window.matchMedia( '(min-width: 1024px)' )],
        ['medium', window.matchMedia( '(min-width: 769px)' )],
        ['small', window.matchMedia( '(min-width: 640px)' )],
        ['default', { matches: true }],
    ];

    const videoData = [...videos].map( video => {
        return {
            video,
            sources: {
                large: video.dataset?.large,
                medium: video.dataset?.medium,
                small: video.dataset?.small,
                default: video.dataset?.default,
            },
            type: {
                large: video.dataset?.largeType,
                medium: video.dataset?.mediumType,
                small: video.dataset?.smallType,
                default: video.dataset?.defaultType,
            }
        };
    } );

    setVideoSrcs();
    window.addEventListener( 'resize', debounce( setVideoSrcs, 400 ) );

    requestAnimationFrame( () => {
        autoplayVideos();
    } );
    document.addEventListener( 'touchstart', autoplayVideos, { once: true } );
    function autoplayVideos() {
        /** @type {NodeListOf<HTMLVideoElement>} */
        const autoplayVideos = document.querySelectorAll( 'video[autoplay][muted]' );
        autoplayVideos.forEach( video => video.paused && video.play() );
    }

    // Loop through media queries (largest first and set the src of the video to the first match)
    function setVideoSrcs() {
        videoData.forEach( data => {
            for ( let [key, size] of mediaQueries ) {
                if ( !size.matches ) continue;
                const src = data.sources[key];
                const type = data.type[key];
                if ( !src ) continue;
                // If the size hasn't changed, don't do anything
                if ( data.video.getAttribute( 'data-active-size' ) === key ) return;

                removeVideoSource( data.video );

                data.video.setAttribute( 'data-active-size', key );
                const source = document.createElement( 'source' );
                source.src = src;
                source.type = type;
                data.video.appendChild( source );
                data.video.load();
                if ( data.video.hasAttribute( 'autoplay' ) ) data.video.play();

                // Short circuit as our source has been set
                return;
            }
        } );
    }

    function removeVideoSource( video ) {
        video.pause();
        video.removeAttribute( 'src' );
        if ( video.children.length > 0 ) {
            video.removeChild( video.firstElementChild );
        }
        video.load();
    }
} );
